<template>
  <div class="body_area">


    <div class="block-header">
      <div class="container">
        <div class="row clearfix">
          <div class="col-lg-6 col-md-12">
            <h1 class="mb-1 mt-1">리드 추가</h1>
          </div>
        </div>
        <div class="bh_divider"></div>
        <div class="row clearfix">
          <div class="col-lg-12 col-md-12">
            <nav class="navbar navbar-expand-lg page_menu">
              <div class="collapse navbar-collapse" id="Blog_app" style="display: block;">
                <ul class="navbar-nav mr-auto">
                  <li class="nav-item active "><a href="javascript:void(0);" class="nav-link"  @click="toLeadPage">리드</a></li>
                  <li class="nav-item "><a href="javascript:void(0);" class="nav-link"  @click="toListPage">리스트</a></li>
                </ul>
                <div>
                  <button type="button" class="btn btn-secondary" v-if="leadCode == null" @click="addLead">생성</button>
                  <button type="button" class="btn btn-secondary" v-if="leadCode != null" @click="editLead">수정</button>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>

<!-- 전화번호 성별  생년월일 나이 회사명 리드점수  -->

    <div class="container">
      <!-- Input -->
      <div class="row clearfix">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="card">
            <div class="header">
              <h2><strong>리드 추가</strong> </h2>
            </div>
            <div class="body">
<!--              <h2 class="card-inside-title">이메일</h2>-->
              <div class="row clearfix">
                <div class="col-sm-12">
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="email" :readonly="$route.params.leadCode != null" placeholder="이메일" />
                  </div>
                </div>
              </div>

<!--              <h2 class="card-inside-title">이름</h2>-->
              <div class="row clearfix">
                <div class="col-sm-12">
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="name" placeholder="이름" />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="card">
            <div class="body">


              <h2 class="card-inside-title">개인 정보</h2>

              <div class="row clearfix">
                <div class="col-sm-6">
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="phone" placeholder="전화번호" />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="birthday" placeholder="생년월일" />
                  </div>
                </div>
              </div>

              <div class="row clearfix">
                <div class="col-sm-6">
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="age" placeholder="나이" />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="gender" placeholder="성별" />
                  </div>
                </div>
              </div>

              <div class="row clearfix">
                <div class="col-sm-6">
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="company" placeholder="회사명" />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="leadScore" placeholder="리드점수" />
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>


        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="card">
            <div class="body">


              <h2 class="card-inside-title">주소</h2>

              <div class="row clearfix">
                <div class="col-sm-6">
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="zipcode" placeholder="우편번호" />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <button type="button" class="btn btn-primary" @click="openDaumPostcode">우편번호 조회</button>
                  </div>
                </div>
              </div>



              <div class="row clearfix">
                <div class="col-sm-12">
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="address1" placeholder="주소" readonly />
                  </div>
                </div>

              </div>
              <div class="row clearfix">
                <div class="col-sm-12">
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="address2" placeholder="상세주소" />
                  </div>
                </div>

              </div>




            </div>
          </div>
        </div>









      </div>
      <!-- #END# Input -->


      <div v-if="zipcodeModal" >
        <div class="modal fade show" id="defaultModal" tabindex="-1" role="dialog" style="top:140px;">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="title" id="defaultModalLabel">우편번호 조회</h4>
              </div>
              <div class="modal-body" style="overflow: scroll; height: 650px;">
                <VueDaumPostcode @complete="searchResult" />
              </div>
              <div class="modal-footer">
<!--                <button type="button" class="btn btn-primary waves-effect">선택</button>-->
                <button type="button" class="btn btn-danger btn-simple waves-effect" data-dismiss="modal" @click="closeZipcodeModal">닫기</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--#END# DateTime Picker -->
    </div>

  </div>
</template>


<script>
import { VueDaumPostcode } from "vue-daum-postcode"

export default {
  name: 'LeadAddPage',
  components: {
    VueDaumPostcode
  },
  data() {
    return {
      zipcodeModal : false,

      email : null,
      name : null,
      phone : null,
      birthday : null,
      age : null,
      gender : null,
      company : null,
      leadScore : null,
      zipcode : null,
      address1 : null,
      address2 : null,

      leadCode : null,
    }
  },
  methods: {
    editLead(){
      console.log("dd")
      var param = {
        companyCode : this.$store.getters.getUserCode,
        leadCode : this.leadCode,
        email : this.email,
        name : this.name,
        phone : this.phone,
        birthday : this.birthday,
        age : this.age,
        gender : this.gender,
        company : this.company,
        leadScore : this.leadScore,
        zipcode : this.zipcode,
        address1 : this.address1,
        address2 : this.address2,
      }

      this.api.editLead(param)
      .then((res)=>{

        if(this.utils.preApiHandle(res)) {
          console.log("list list res : ", res)
        }
        if(res.code == 0){
          alert("수정되었습니다.")
          this.$router.push({name:"LeadListPage"})
        } else {
          alert("오류가 발생했습니다.")
        }

      })

    },
    openDaumPostcode() {
      this.zipcodeModal = !this.zipcodeModal;

      document.querySelector("body").classList.add("modal-open")

    },
    closeZipcodeModal(){
      this.zipcodeModal = false;

      document.querySelector("body").classList.remove("modal-open")
    },
    searchResult(res) {
      if(res.userSelectedType == "R") {
        this.address1 = `${res.address} (${res.buildingName})`;
      }
      if(res.userSelectedType == "J") {
        this.address1 = res.jibunAddress;
      }

      this.zipcode = res.zonecode;
      this.zipcodeModal = false;
    },
    addLead(){
      var param = {
        companyCode : this.$store.getters.getUserCode,
        email : this.email,
        name : this.name,
        phone : this.phone,
        birthday : this.birthday,
        age : this.age,
        gender : this.gender,
        company : this.company,
        leadScore : this.leadScore,
        zipcode : this.zipcode,
        address1 : this.address1,
        address2 : this.address2,
      }

      console.log(param)

      this.api.addLead(param)
      .then((res)=>{

        if(this.utils.preApiHandle(res)) {
          console.log("list list res : ", res)
        }

        if(res.code == 0){
          alert("저장되었습니다.")

          if(this.$route.params.status == "1"){
            this.$router.push({name:"LeadInListPage"})

          } else {
            this.$router.push({name:"LeadListPage"})

          }
        } else {
          alert("오류가 발생했습니다.")
        }

      })

    },
    toLeadPage(){
      this.$router.push({name:"LeadListPage"})
    },
    toListPage(){
      this.$router.push({name:"ListListPage"})
    },
  },
  created() {
    console.log('LeadAddPage created',this.$route.params.leadCode)

    if(this.$route.params.leadCode != null){
      var param = {
        companyCode : this.$store.getters.getUserCode,
        leadCode : this.$route.params.leadCode
      }

      console.log(param)

      this.api.getLeadDetail(param)
      .then((res)=>{

        if(this.utils.preApiHandle(res)) {
          console.log("list list res : ", res)
        }

        if(res.code == 0){
          this.email = res.lead.email
          this.name = res.lead.name
          this.phone = res.lead.phone
          this.birthday = res.lead.birthday
          this.age = res.lead.age
          this.gender = res.lead.gender
          this.company = res.lead.company
          this.leadScore = res.lead.leadScore
          this.zipcode = res.lead.zipcode
          this.address1 = res.lead.address1
          this.address2 = res.lead.address2
          this.leadCode = res.lead.leadCode

        } else {
          alert("오류가 발생했습니다.")
        }
      })

    }

  },
  mounted() {
    console.log('LeadAddPage created')
  },
  beforeDestroy() {
    console.log('LeadAddPage beforeDestroy')
  }
}
</script>

